import type { CSSProperties } from "react";

/** Paleta unificada academia: verde, azul, rojo, amarillo */

export const PAYMENT_STATUS_COLORS = {
  paid: "#4bd542",
  unpaid: "blue",
  overdue: "#ff4d4f",
  partial_payment: "yellow",
  pending_verification: "#1677ff",
} as const;

export const PAYMENT_STATUS_LABELS: Record<string, string> = {
  paid: "Pagado",
  unpaid: "Pendiente por pago",
  overdue: "En mora",
  partial_payment: "Acuerdo de pago parcial",
  pending_verification: "Verificación de pago",
};

export const PROGRAM_STUDENT_STATUS_COLORS: Record<string, string> = {
  active: "#4bd542",
  inactive: "#ff4d4f",
  pause: "yellow",
  completed: "blue",
};

export const PROGRAM_STUDENT_STATUS_LABELS: Record<string, string> = {
  active: "Activo",
  inactive: "Inactivo",
  pause: "Pausado",
  completed: "Completado",
};

export const QUALIFICATION_STATUS_COLORS: Record<string, string> = {
  approved: "#4bd542",
  disapproved: "#ff4d4f",
};

export const QUALIFICATION_STATUS_LABELS: Record<string, string> = {
  approved: "Aprobado",
  disapproved: "Reprobado",
};

export const EQUIPMENT_RENT_STATUS_COLORS: Record<string, string> = {
  pending_payment: "#ff4d4f",
  successful_payment: "#4bd542",
};

export const EQUIPMENT_RENT_STATUS_LABELS: Record<string, string> = {
  pending_payment: "Pendiente por pago",
  successful_payment: "Pago exitoso",
};

export function getPaymentStatusColor(status: string): string {
  return (
    PAYMENT_STATUS_COLORS[status as keyof typeof PAYMENT_STATUS_COLORS] ||
    "blue"
  );
}

export function getPaymentStatusLabel(status: string): string {
  return PAYMENT_STATUS_LABELS[status] || status;
}

export type PaymentGlobalStatus =
  | "al_dia"
  | "en_mora"
  | "pago_parcial"
  | "sin_cuotas"
  | "en_verificacion";

export const GLOBAL_PAYMENT_STATUS_COLORS: Record<string, string> = {
  al_dia: "#4bd542",
  en_mora: "#ff4d4f",
  pago_parcial: "yellow",
  sin_cuotas: "blue",
  pendiente: "blue",
  en_verificacion: "#1677ff",
};

/** Texto negro en fondo amarillo; blanco en el resto */
export function getBadgeTextColor(background: string): string {
  const normalized = background.toLowerCase();
  if (normalized === "yellow" || normalized.includes("yellow")) {
    return "#000";
  }
  return "#fff";
}

export const ACADEMY_ROUNDED_BADGE_STYLE: CSSProperties = {
  textAlign: "center",
  padding: "8px 16px",
  borderRadius: 20,
  display: "inline-block",
  fontSize: "0.74rem",
  fontWeight: 500,
  whiteSpace: "nowrap",
};

export const ACADEMY_ROUNDED_BADGE_STYLE_COMPACT: CSSProperties = {
  ...ACADEMY_ROUNDED_BADGE_STYLE,
  padding: "5px 27px",
};
